// Per-config field "filled" check. Surfaces total/required completeness to
// the UI so a user can spot missing values before running the engine.

const REQUIRED_FIELDS = [
  { key: 'calcDirection', label: 'calcDirection' },
  { key: 'pointValue.amount', label: 'pointValue.amount' },
  { key: 'workingHoursSource', label: 'workingHoursSource' },
  { key: 'rounding.salary', label: 'rounding.salary' },
  { key: 'rounding.deductions', label: 'rounding.deductions' },
  { key: 'deductionOrder', label: 'deductionOrder' },
  { key: 'effectiveFrom', label: 'effectiveFrom' },
];

const OPTIONAL_FIELDS = [
  { key: 'minWagePerHour', label: 'minWagePerHour' },
  { key: 'minWageAvgHours', label: 'minWageAvgHours' },
  { key: 'overtimeBase', label: 'overtimeBase' },
  { key: 'averageCalcMethod', label: 'averageCalcMethod' },
  { key: 'allowanceMethods.mealAllowance', label: 'allowanceMethods.meal' },
  { key: 'allowanceMethods.holidayAllowance', label: 'allowanceMethods.holiday' },
  { key: 'topLevelNmb.code', label: 'topLevelNmb.code' },
  { key: 'dopunaConfig.fillEarningCode', label: 'dopunaConfig.fillCode' },
  { key: 'earningCodes', label: 'earningCodes', arrayMin: 1 },
  { key: 'deductionTypes', label: 'deductionTypes', arrayMin: 1 },
  { key: 'otherPaymentTypes', label: 'otherPaymentTypes', arrayMin: 1 },
];

function readPath(obj, path) {
  return path
    .split('.')
    .reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
}

function fieldFilled(config, spec) {
  const v = readPath(config, spec.key);
  if (spec.arrayMin != null) {
    return Array.isArray(v) && v.length >= spec.arrayMin;
  }
  return v != null && v !== '' && !(Array.isArray(v) && v.length === 0);
}

export function computeConfigCompleteness(config) {
  if (!config) {
    return {
      requiredFilled: 0,
      requiredTotal: REQUIRED_FIELDS.length,
      optionalFilled: 0,
      optionalTotal: OPTIONAL_FIELDS.length,
      missingRequired: REQUIRED_FIELDS.map((f) => f.label),
    };
  }
  const missingRequired = REQUIRED_FIELDS.filter(
    (f) => !fieldFilled(config, f)
  ).map((f) => f.label);
  const filledRequired = REQUIRED_FIELDS.length - missingRequired.length;
  const filledOptional = OPTIONAL_FIELDS.filter((f) =>
    fieldFilled(config, f)
  ).length;
  return {
    requiredFilled: filledRequired,
    requiredTotal: REQUIRED_FIELDS.length,
    optionalFilled: filledOptional,
    optionalTotal: OPTIONAL_FIELDS.length,
    missingRequired,
  };
}
